import { render, staticRenderFns } from "./MainSideMenu.vue?vue&type=template&id=794a7fff&scoped=true&"
import script from "./MainSideMenu.vue?vue&type=script&lang=ts&"
export * from "./MainSideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MainSideMenu.vue?vue&type=style&index=0&id=794a7fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a7fff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VDivider,VNavigationDrawer})
